<template>
  <WhitePage :loading="$store.getters.loading">
    <title-bar>ゲーム設定</title-bar>
    <!-- <setting-nav></setting-nav> -->
    <b-form>
      <b-form-group id="twitter" label="Twitter連携"
        description="Twitterアカウントでログインができるようになります。仕様が変更になる可能性もあるので、パスワードは忘れないようにしてください。">
        <b-button @click="twitter()"><img :src="require('@/assets/ui/sign-in-with-twitter.png')" /></b-button>
        <template v-if="twitterAvailable">
          <label>登録済</label>
        </template>
        <template v-else>
          <label>未登録</label>
        </template>

      </b-form-group>
      <b-form-group id="discord" label="Discord連携"
        description="Discordの任意のチャンネルにWebhookで通知します。あまり意味はないです。">
        <b-form-input v-model="form.discordWebhook"
          placeholder="webhook URL" />
        <b-form-checkbox v-model="form.discordWebhookUpdateNotify"
          :value="1" :unchecked-value="0">
          更新通知
        </b-form-checkbox>
        <b-form-checkbox v-model="form.discordWebhookNoActionAlert"
          :value="1" :unchecked-value="0">
          未宣言アラート（３０分くらい前に通知します）
        </b-form-checkbox>
        <b-button type="button" variant="primary" @click="onSubmit">登録</b-button>
        <response-message ref="response" :value="postMessage1" />
      </b-form-group>
      <hr>
      <b-alert show variant="warning">
        <b-button variant="warning" @click="warning = !warning">
          <font-awesome-icon icon="exclamation-triangle" class="icon fa-1x" />
        </b-button>
        緊急コマンド。必要になったら使ってください。
        <div v-if="warning">
          <hr>
          <b-form-group id="escape" label="緊急脱出"
            description="異世界で進行不能になった場合、不奇跡世界へ緊急脱出することができます。">
            <b-form-checkbox v-model="form.emergencyEscape"
              :value="1" :unchecked-value="0">
              緊急脱出し、不奇跡世界へ移動する。
            </b-form-checkbox>
          </b-form-group>
          <b-button variant="warning" @click="onSubmit">登録</b-button>
          <response-message ref="response" :value="postMessage1" />
        </div>
      </b-alert>
      <hr>
      <b-alert show variant="danger">
        <b-button variant="danger" @click="danger = !danger">
          <font-awesome-icon icon="exclamation-triangle" class="icon fa-1x" />
        </b-button>
        この先はあぶないメニュー。取り消せません。
        <hr v-if="danger">
        <b-form-group id="delete" label="キャラクター削除"
          description="愛称を入力してキャラクターを削除します。" v-if="danger">
          <b-form-input v-model="form.deleteName" />
          <b-button variant="danger" @click="deleteCharacter">削除</b-button>
          <response-message ref="response" :value="postMessage2" />
        </b-form-group>
      </b-alert>
    </b-form>
  </WhitePage>
</template>

<script>
// import phina from 'phina.js'
import store from '@/store'
import WhitePage from '@/components/WhitePage'
import CheckLogin from '@/components/mixin-checkLogin'
import TitleBar from '@/components/TitleBar'
// import SettingNav from '@/components/SettingNav'
import ResponseMessage from '@/components/ResponseMessage'
export default {
  components: {
    WhitePage,
    TitleBar,
    // SettingNav,
    ResponseMessage
  },
  data () {
    return {
      form: {
        discordWebhook: '',
        discordWebhookUpdateNotify: 0,
        discordWebhookNoActionAlert: 0,
        deleteName: '',
        emergencyEscape: 0,
      },
      twitterAvailable: false,
      loading: false,
      postMessage1: {},
      postMessage2: {},
      danger: false,
      warning: false,
    }
  },
  mixins: [
    CheckLogin
  ],
  methods: {
    setData (response) {
        this.form.discordWebhook = response.discordWebhook
        this.form.discordWebhookUpdateNotify = response.discordWebhookUpdateNotify
        this.form.discordWebhookNoActionAlert = response.discordWebhookNoActionAlert
        this.twitterAvailable = response.twitterAvailable
        this.form.emergencyEscape = response.emergencyEscape
    },
    twitter () {
      this.$store.dispatch('signInTwitter', 'authorizeTwitter')
        .then((response)=>{
          if(response.error === '200 OK'){
            window.location = response.url
          }else{
            this.postMessage1 = response
          }
        })
    },
    onSubmit () {
      this.$store.dispatch('setSetting', this.form)
        .then((response)=>{
          this.postMessage1 = response
        })
    },
    deleteCharacter () {
      this.$store.dispatch('deleteCharacter', this.form)
        .then((response)=>{
          this.postMessage2 = response
          this.checkLogin()
        })
    },
  },
  beforeRouteEnter (route, redirect, next) {
    store.dispatch('getSetting')
      .then((response) => {
        next(vm => vm.checkService(response))        
      })
  },
  created () {
    this.checkLogin()
  },
  // mounted () {
  //   phina.global.app.currentScene.exit('MainScene')
  // }
}
</script>

<style lang="scss" scoped>
.danger {
  color: #F00;
}
</style>
